<div class="d-flex flex-column h-100">
  <app-navigation class="mb-2 mat-typography"></app-navigation>

  <div class="container-fluid mat-typography">
    <router-outlet></router-outlet>
  </div>

  <app-footer color="primary mat-typography"></app-footer>
</div>
